import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import './new-season-badge.scss'

interface NewSeasonBadgeProps {
  className?: string
  testId?: string
}

export function NewSeasonBadge({ className, testId = 'new-season_badge' }: Readonly<NewSeasonBadgeProps>) {
  const { t } = useTranslation()

  return (
    <span className={clsx('new-season-badge', className)} data-testid={testId}>
      {t('products-page.product-card.new')}
    </span>
  )
}
